module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_buchung 2.afedf8ca.svg";